import React, { useEffect } from 'react';
import { useHistory } from 'react-router';
import { Card, CardContent, Grid, Typography } from '@material-ui/core';
import PremissionTable from '../Table/PremissionTable';

function SuperAdminRoleMatrix(props) {
    const history = useHistory();

    useEffect(() => {
        history.push({
            state: { breadCrumbLabel: props.breadCrumbLabel, breadCrumbPath: props.breadCrumbPath },
        });
    }, []);

    return (
        <>
        <Card className="custom-table">
            <CardContent className="card-title-display">
                <Grid item xs={12} sm={8}>
                    <Typography className="card-title">Super Admin Role Matrix</Typography>
                </Grid>
            </CardContent>    
            <CardContent className="card-table-display">
                <PremissionTable />
            </CardContent>
        </Card>
        {/* <div>
            <div style={{ textAlign: 'center', fontFamily: 'Rubik' }}>
                <h1> SUPER ADMIN ROLE MATRIX</h1>
            </div>
            
        </div> */}
        </>
    );
}

export default SuperAdminRoleMatrix;
